import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../lib/i18n';
const images = [{
  src: 'https://cdn.magicpatterns.com/uploads/4tBfbxmnmE4DXauSPPzrqV/ChatGPT_Image_27_may_2026,_15_55_24.png',
  alt: 'Picnic en la playa con arco de tul y velas al atardecer'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vF7LkjEFznjEzXXWV1BubP/ChatGPT_Image_May_27,_2026_at_04_00_02_PM.png',
  alt: 'Picnic romántico frente al océano con cactus al atardecer'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/6Y3TdoC3W5VHTVHus7vAgx/ChatGPT_Image_May_27,_2026_at_04_02_17_PM.png',
  alt: 'Familia disfrutando un picnic frente al mar al atardecer'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/tyrKWqVBjohnYkcRCF85Ch/ChatGPT_Image_May_27,_2026_at_04_04_13_PM.png',
  alt: 'Picnic íntimo entre rocas volcánicas con vistas a Los Gigantes'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/pvVEKokC8daJT7krUj1QWa/ChatGPT_Image_May_27,_2026_at_04_44_31_PM.png',
  alt: 'Picnic de cumpleaños con globos dorados frente al océano'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/dEjHyMBVNA4NCL4NnqHt6j/IMG_6596_2.jpg',
  alt: 'Tabla de embutidos ibéricos, quesos y flores comestibles'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/roKWw1kLtqSyjDe3JoNc1j/IMG_6594_2.jpg',
  alt: 'Mesa gourmet con vistas al mar y barco de vela al fondo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/c6kCEEuvPZ7ZKcS5YskXGy/foto_web_1.jpg',
  alt: 'Tabla de embutidos y quesos compartida entre amigos con romero fresco'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/kzD1fiKuDfvnqjxVcvjtqy/foto_web_2.jpg',
  alt: 'Bandeja de frutas tropicales con sandía, mango, granada y uvas'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rLsJqedbtLDXbrojJbmt6J/foto_web_3.jpg',
  alt: 'Tabla artesanal de quesos curados, jamón ibérico y frutos secos'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/mHqKVLz2jhYVvvF1LRzgwJ/foto_web_4.jpg',
  alt: 'Mesa con frutas frescas, pan artesano y nachos sobre cestería natural'
}];
export function Gallery() {
  const {
    t
  } = useLanguage();
  return <section id="galeria" className="py-16 sm:py-24 lg:py-32 px-5 sm:px-8 lg:px-24 bg-ivory w-full overflow-hidden" data-id="element-169">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 1.2,
      ease: [0.22, 1, 0.36, 1]
    }} className="text-center max-w-3xl mx-auto mb-12 sm:mb-16 lg:mb-20" data-id="element-170">
        <p className="uppercase tracking-[0.3em] text-olive text-[9px] sm:text-[10px] font-semibold mb-4 sm:mb-6" data-id="element-171">
          {t('gallery.tag')}
        </p>
        <h2 className="font-display text-fluid-h2 text-volcanic font-light leading-[1.1]" data-id="element-172">
          {t('gallery.title1')} <br data-id="element-173" />
          <span className="font-script text-fluid-script text-terracotta inline-block mt-[-0.1em]" data-id="element-174">
            {t('gallery.title2')}
          </span>
        </h2>
        <p className="text-volcanic/80 leading-relaxed text-[14px] sm:text-[15px] max-w-xl mx-auto font-light mt-6 sm:mt-8" data-id="element-175">
          {t('gallery.desc')}
        </p>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-4 sm:gap-5 lg:gap-6 max-w-[1400px] mx-auto" data-id="element-176">
        {images.map((img, i) => {
        const layouts = ['lg:col-span-7 lg:row-span-2 h-[300px] sm:h-[420px] lg:h-auto', 'lg:col-span-5 h-[260px] sm:h-[320px] lg:h-[340px]', 'lg:col-span-5 h-[260px] sm:h-[320px] lg:h-[340px]', 'lg:col-span-6 h-[260px] sm:h-[340px] lg:h-[400px]', 'lg:col-span-6 h-[260px] sm:h-[340px] lg:h-[400px]', 'lg:col-span-4 h-[280px] sm:h-[360px] lg:h-[440px]', 'lg:col-span-4 h-[280px] sm:h-[360px] lg:h-[440px]', 'lg:col-span-4 h-[280px] sm:h-[360px] lg:h-[440px]', 'lg:col-span-3 h-[280px] sm:h-[360px] lg:h-[380px]', 'lg:col-span-3 h-[280px] sm:h-[360px] lg:h-[380px]', 'lg:col-span-3 h-[280px] sm:h-[360px] lg:h-[380px]', 'lg:col-span-3 h-[280px] sm:h-[360px] lg:h-[380px]'];
        const layout = layouts[i] ?? 'lg:col-span-4 h-[280px] sm:h-[360px]';
        return <motion.div key={img.src} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 1,
          delay: i * 0.1,
          ease: [0.22, 1, 0.36, 1]
        }} className={`group relative overflow-hidden rounded-sm bg-sand ${layout}`} data-id="element-177">
              <img src={img.src} alt={img.alt} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[2s] ease-out" data-id="element-178" />
              <div className="absolute inset-0 bg-gradient-to-t from-volcanic/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-179" />
            </motion.div>;
      })}
      </div>
    </section>;
}